import { Component, Input, OnChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateTime } from 'luxon';

@Component({
    selector: 'app-mazars-datepicker',
    templateUrl: './mazars-datepicker.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: MazarsDatePickerComponent,
        },
    ],
})
export class MazarsDatePickerComponent implements ControlValueAccessor, OnChanges {
    @Input({ required: true }) uid: string;
    @Input() placeholder: string;
    @Input() minDate?: Date;
    @Input() maxDate?: Date;
    @Input() minYear?: number;
    @Input() showClear = false;
    @Input() view = 'date';
    @Input() dateFormat = 'dd. MM yy';

    value: Date;
    isDisabled: boolean;
    yearRange: string;
    private minYearRange = 1900;
    private yearThreshold = 100;

    onChange = (_) => {
        // This is intentional
    };

    onTouched = () => {
        // This is intentional
    };

    ngOnChanges() {
        const today = new Date();
        const maxYearRange = this.maxDate instanceof Date ? this.maxDate.getFullYear() : today.getFullYear() + this.yearThreshold;
        this.minYearRange = this.minYear ? this.minYear : this.minDate instanceof Date ? this.minDate.getFullYear() : this.minYearRange;
        this.yearRange = `${this.minYearRange}:${maxYearRange}`;
    }

    writeValue(obj: any): void {
        if (obj && obj instanceof DateTime) {
            if (obj) {
                const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                const localDate = DateTime.fromISO(obj.toString(), {zone: timezone});
                this.value = localDate.toJSDate();
            } else {
                this.value = null;
            }
        } else {
            this.value = obj;
        }

        this.onValueChange();
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    onValueChange() {
        if (this.value == null) {
            this.onChange(null);
        } else {
            const utcDateString = new Date(this.value.getTime() - this.value.getTimezoneOffset() * 60000).toISOString();
            this.onChange(utcDateString);
        }
    }

    onClearClick() {
        this.onChange(null);
        this.onTouched();
    }

    onBlur() {
        this.onTouched();
    }
}
